module.exports = __webpack_public_path__ + "img/lera-work-2.5932be3f.jpg";